import styled from 'styled-components'
import { GRAY2, PRIMARY_TEXT } from 'constants/colors'
import { Flex } from 'components/common/styles'

export const InputsContainer = styled.div`
  border: 1px solid ${GRAY2};
  border-radius: 12px;
  margin-bottom: 8px;
`

export const InputWrapper = styled(Flex)`
  min-height: 48px;
  padding: 14px;
  font-size: 14px;
  line-height: 20px;

  &:not(:first-child) {
    border-top: 1px solid ${GRAY2};
  }

  .MuiFormControl-root {
    margin: 0;
  }
`

export const GreyText = styled.span`
  color: ${PRIMARY_TEXT};
  opacity: 0.4;
`

export const Task = styled(GreyText)`
  font-size: 12px;
  line-height: 16px;
`
